import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000'

function Messages({ patientId, senderRole, senderName }) {
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState('')
  const bottomRef = useRef(null)

  useEffect(() => {
    fetchMessages()
    const interval = setInterval(fetchMessages, 10000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  const fetchMessages = () => {
    axios.get(API + '/patients/' + patientId + '/messages')
      .then(res => setMessages(res.data))
      .catch(err => console.error(err))
  }

  const handleSend = () => {
    if (!newMessage.trim()) return
    axios.post(API + '/messages', {
      patient_id: patientId,
      sender_role: senderRole,
      sender_name: senderName,
      message_text: newMessage
    }).then(() => {
      setNewMessage('')
      fetchMessages()
    }).catch(err => console.error(err))
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const formatTime = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'clamp(320px, 50vh, 500px)' }}>
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', background: '#f7fafc', borderRadius: '12px', marginBottom: '12px' }}>
        {messages.length === 0 && (
          <div style={{ textAlign: 'center', color: '#888', fontSize: '16px', marginTop: '40px' }}>
            No messages yet. Start the conversation below.
          </div>
        )}
        {messages.map(msg => {
          const isMe = msg.sender_role === senderRole
          return (
            <div key={msg.id} style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
              <div style={{ maxWidth: '70%' }}>
                <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px', textAlign: isMe ? 'right' : 'left' }}>
                  {msg.sender_name} · {formatTime(msg.created_at)}
                </div>
                <div style={{
                  padding: '12px 16px',
                  borderRadius: isMe ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                  background: isMe ? '#2c7a7b' : 'white',
                  color: isMe ? 'white' : '#2d3748',
                  fontSize: '16px',
                  lineHeight: '1.5',
                  border: isMe ? 'none' : '1.5px solid #e2e8f0'
                }}>
                  {msg.message_text}
                </div>
              </div>
            </div>
          )
        })}
        <div ref={bottomRef} />
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <textarea
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type a message... (Enter to send)"
          style={{ flex: 1, padding: '12px', fontSize: '16px', border: '1.5px solid #cbd5e0', borderRadius: '8px', resize: 'none', height: '52px', lineHeight: '1.5' }}
        />
        <button
          onClick={handleSend}
          style={{ padding: '12px 24px', background: '#2c7a7b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', fontWeight: 500 }}
        >
          Send
        </button>
      </div>
    </div>
  )
}

export default Messages